import React from "react";
import { Button, FormControl } from "react-bootstrap";

import { isValid as isValidPassword } from "@helpers/passwordValidation";
import { PasswordValidation } from "@legacyComponents/login/PasswordValidation";
import { PasswordResetForm } from "./PasswordResetForm";

import "./PasswordReset.scss";

interface Props {
  isAdvancedSecurity: boolean;
  password?: string;
  passwordConfirmation?: string;
  passwordLength: number;
}

interface State {
  password?: string;
  passwordConfirmation?: string;
}

class PasswordReset extends React.Component<Props, Readonly<State>> {
  constructor(props: Props) {
    super(props);

    const { password, passwordConfirmation } = this.props;

    this.state = {
      password: password !== null ? password : "",
      passwordConfirmation: passwordConfirmation !== null ? passwordConfirmation : "",
    };
  }

  handlePasswordChanged = (event: React.ChangeEvent<FormControl.FormControlProps>) => {
    this.setState({ password: event.currentTarget.value as string });
  };

  handlePasswordConfirmationChanged = (event: React.ChangeEvent<FormControl.FormControlProps>) => {
    this.setState({ passwordConfirmation: event.currentTarget.value as string });
  };

  render() {
    const { isAdvancedSecurity, passwordLength } = this.props;
    const { password, passwordConfirmation } = this.state;

    const validPasswords = isValidPassword(
      password,
      passwordConfirmation,
      passwordLength,
      isAdvancedSecurity
    );
    const { isValid } = validPasswords;

    return (
      <>
        <PasswordResetForm
          password={password}
          passwordConfirmation={passwordConfirmation}
          onPasswordChanged={this.handlePasswordChanged}
          onPasswordConfirmationChanged={this.handlePasswordConfirmationChanged}
        />
        <PasswordValidation
          isAdvancedSecurity={isAdvancedSecurity}
          passwordLength={passwordLength}
          {...validPasswords}
        />
        <Button
          bsStyle="primary"
          type="submit"
          className="password-reset-button--large"
          disabled={!isValid}
        >
          Set New Password
        </Button>
      </>
    );
  }
}

export { PasswordReset };
